
    import CommitmentLevel from "./CommitmentLevel.vue";
    import DepartmentView from "./DepartmentView.vue";
    import CalendarFilterPanel from "./CalendarFilterPanel.vue";
    import { Component, Vue, Prop, Watch } from "vue-property-decorator";
    import FullCalendar, {
        CalendarOptions,
        EventApi,
        DateSelectArg,
        EventClickArg,
    } from "@fullcalendar/vue";
    import adaptivePlugin from '@fullcalendar/adaptive';
    import dayGridPlugin, { DayGridView } from "@fullcalendar/daygrid";
    // import timeGridPlugin from "@fullcalendar/timegrid";
    import interactionPlugin from "@fullcalendar/interaction";
    import { INITIAL_EVENTS, createEventId } from "../../event-utils";
    // import Model from "./ScheduleRequest.vue";
    import SharedModal from "../shared/SharedModal.vue";
    import SaveMsgPopUp from "../shared/SaveMsgPopUp.vue";
    import NotificationMsgPopUp from "../shared/NotificationMsgPopUp.vue"
    import TrainingVideoLink from '../shared/TrainingVideoLink.vue';
    import TrainingVideos from '../shared/TrainingVideos.vue';
    import { mapGetters } from "vuex";
    import { ORSchedule, Event } from "@/models";
    import { namespace } from "vuex-class";
    import moment from "moment";
    const schedule = namespace("schedule");
    const profile = namespace("profile");
    import { VclFacebook, VclInstagram } from "vue-content-loading";
    // import { bus } from "../../main";
    import bus from '../../eventBus'
    import tippy from 'tippy.js';
    import 'tippy.js/dist/tippy.css';
    import WelcomeMsgPopup from "../profile/WelcomeMsgPopup.vue";
    import ConfirmMsgPopUp from "../shared/ConfirmMsgPopUp.vue";
    import AlertPopUp from "../shared/AlertPopUp.vue";
    import { useAppInsights } from '../../store/modules/AppInsights'

    @Component({
        components: {
            FullCalendar, // make the <FullCalendar> tag available
            SharedModal,
            CommitmentLevel,
            CalendarFilterPanel,
            SaveMsgPopUp,
            VclFacebook,
            VclInstagram,
            DepartmentView,
            WelcomeMsgPopup,
            ConfirmMsgPopUp,
            AlertPopUp,
            NotificationMsgPopUp,
            TrainingVideoLink,
            TrainingVideos
        },        
        computed: {
            ...mapGetters(["profileData"]),
            ...mapGetters(["oidcUser"]),
        },
    })
    export default class MyScheduleView extends Vue {
        @Prop() viewFlag: any; //--firstly it would be  "cal"
        sharedRequest: any;
        leftNavBar: boolean = false;
        isAlertModalVisible: boolean = false;
        alertMsgValue: string = '';
        $refs!: {
            fullCalendarCurrentMonth: HTMLFormElement;
            calendarfilter: any;
        };
        isPanelOpen: boolean = false;
        oidcUser!: any;
        @profile.State
        public profileData!: any;
        @profile.State
        isAdmin!: boolean;
        @profile.State
        isImpersonating!: boolean;

        @profile.State
        appInsightEventData!: any;

        private currentEvents: EventApi[] = [];
        private currentDate: string = "March, 2021";
        confirmMsgValue = "You have not submitted your shift requests. Are you sure you want to navigate away?";
        isConfirmModalVisible: boolean = false;

        private allocatedHours: number = 0;
        private backDate = new Date();
        private forwardDate = new Date();
        private selectedDates: Array<string | string> = [];
        private isModalVisible = false;

        private currentMonthCalendarApi: any;
        private schedules: any;
        private scheduleStatus = "Unknown";
        currentEvent!: Event;

        updateData: string = "";
        firstName: string = "";
        lastName: string = "";
        nameInitials: string = "";

        isSMPModalVisible: boolean = false;
        isDeptNeedCheck: boolean = true;
        msgValue: string = "";
        classFlag: string = "";
        calSelectedDates: any = {};
        isUnavailabilityAllowed!: boolean;

        employeeType: string = "";
        guranteedHrs: number = 0;
        otHrs: number = 0;
        maxSelfScheduleHours: number = 0;
        displayWSC: boolean = true;

        reqCountWSC: number = 0;
        objCommitmentSubmit: any = {};
        totalWeekendHours: any = 0;
        weekendCount: boolean = false;
        calenderStartforCSD!: Date;
        scheduleId!: string;
        weeksInSchedule: number = 4;
        currentShceduleIndex: number = 0;
        scheduleStartDate!: Date;
        scheduleEndDate!: Date;
        isSelfScheduleAllowed: boolean = false;
        isTierOpen: boolean = false;
        allowSelfScheduleToCommitment: boolean = false;
        needFV = true;
        isWelcomeModalVisible: boolean = false;
        isAllFilterChecked: boolean = true;
        localNextVar: any;
        navForward: any;
        navBackward: any;
        hasSelfScheduleNeedsInPrimaryDept: boolean = false;
        isShiftTradeAllowed: boolean = false;
        defaultSelfScheduleState: string = "";
        isNotificationSuccessModalVisible: boolean = false;
        isNotificationErrorModalVisible: boolean = false;
        successMsgValue: string = "";
        successClassFlag: string = "";
        errorMsgValue: string = "";
        errorClassFlag: string = "";
        isCalenderViewLoaded: boolean = false;

        beforeRouteLeave(to, from, next) {
            let warningMsgStatus = this.checkWarningMessage();

            if(warningMsgStatus) {
                this.localNextVar = next;
                this.navForward = false;
                this.navBackward = false;
                this.isConfirmModalVisible = true;
            }
            else {
                next();
            }
        }

        beforeMonthNavigate(forwards) {
            let warningMsgStatus = this.checkWarningMessage();

            if(warningMsgStatus) {
                this.localNextVar = null;
                this.navForward = forwards;
                this.navBackward = !forwards;
                this.isConfirmModalVisible = true;
            }
            else {
                if (forwards) {
                    this.nextMonth();
                }
                else {
                    this.prevMonth();
                }
            }
        }

        checkWarningMessage() {
            let isPlanSheet = this.scheduleStatus.toUpperCase() == 'PLAN SHEET';

            let reservedEvents = this.events.some(e => e.status === 'Reserved');

            let isCalendarView = this.viewFlag === 'CalView'

            return reservedEvents && isPlanSheet && isCalendarView;
        }

        async confirmedClicked() {
            this.isConfirmModalVisible = false;

            if (this.localNextVar) {
                this.localNextVar();
            }
            else if (this.navForward) {
                this.nextMonth();
            }
            else {
                this.prevMonth();
            }
        }

        private calendarOptions: CalendarOptions = {
            schedulerLicenseKey: '0026605849-fcs-1773694217',
            plugins: [
                adaptivePlugin,
                dayGridPlugin,
                //timeGridPlugin,
                interactionPlugin, // needed for dateClick
            ],
            validRange: {
                start: this.backDate.setMonth(this.backDate.getMonth() - 3), //'2021-03-25',//
                end: this.forwardDate.setMonth(this.forwardDate.getMonth() + 15),
            },
            duration: { weeks: this.weeksInSchedule },
            dateIncrement: { weeks: this.weeksInSchedule },
            views: {
                dayGrid: {
                    type: "dayGrid", // Applicable for: dayGrid and dayGridMonth
                    fixedWeekCount: true,
                    showNonCurrentDates: false,
                },
            },
            headerToolbar: false,
            editable: true,
            eventStartEditable: false,
            selectable: true,
            selectMirror: true,
            dayMaxEvents: false,
            weekends: true,
            select: this.handleDateSelect,
            eventClick: this.handleEventClick,
            eventsSet: this.handleEvents,
            eventDidMount: function (info) {
                if (info.event.extendedProps.type.includes("Need") && !info.event.extendedProps.needFV) {
                    info.el.parentElement?.parentElement?.style.removeProperty("border");
                    info.el.parentElement?.parentElement?.style.removeProperty("background");                     
                }
                else {
                    info.el.parentElement?.parentElement?.style.setProperty("border", "none");
                    info.el.parentElement?.parentElement?.style.setProperty("background", "none");
                    if(info.event.extendedProps.type.includes("Need") && 
                    info.event.extendedProps.dailyEvents>1 && 
                    info.event.extendedProps.schedStatus == 'Posted' && info.event.extendedProps.types.includes("Need"))
                    {
                     info.el.parentElement?.style.setProperty("max-height", "22px");
                     info.el?.style.setProperty("border", "none");
                    }
                }
            },
            eventWillUnmount: function (info){
                if(info.el?.parentElement?.nextElementSibling?.className == 'fc-daygrid-day-bottom' && info.el?.parentElement?.previousElementSibling?.className != 'fc-daygrid-event-harness'){
                    info.el.parentElement?.parentElement?.style.removeProperty("border");
                    info.el.parentElement?.parentElement?.style.removeProperty("background");
                }
            },
            eventContent: function (arg: any) {
                let italicEl = document.createElement("div");
                let eventChanged = arg.event.extendedProps.changed; //if change flag is true
                let dailyEvents = arg.event.extendedProps.dailyEvents;
                let child = document.createElement("div");
                italicEl.appendChild(child);
                if (arg.event.extendedProps.type.includes("Need")) {
                     if (arg.event.extendedProps.needFV) {
                        italicEl.classList.add("main-openneed");
                        child.classList.add("openNeed-title");
                        child.innerHTML = arg.event.title;
                        //append description
                        let descriptionChild = document.createElement("div");
                        descriptionChild.innerHTML = "<span>+</span>";
                        descriptionChild.classList.add("openNeed-plusSign");
                        italicEl.appendChild(descriptionChild);
                        //append PremiumLaborShift Icon
                        var ispremiumLaborLevelIconVisible = arg.event.extendedProps.premiumLaborLevel;
                        let premiumLaborLevelIcon = document.createElement("i");
                        premiumLaborLevelIcon.innerHTML = "hourglass_empty";
                        premiumLaborLevelIcon.classList.add("material-icons");
                        premiumLaborLevelIcon.classList.add("hourGlsEmpty");
                        if(ispremiumLaborLevelIconVisible){
                            italicEl.appendChild(premiumLaborLevelIcon);
                        }
                        if (eventChanged) {
                            //append left visual if change flag is true
                            let leftChild = document.createElement("div");
                            leftChild.innerHTML = "NEW";
                            leftChild.classList.add("openNeed-new");
                            italicEl.appendChild(leftChild);
                            //append logo
                            let logoChild = document.createElement("div");
                            logoChild.innerHTML = "<span>circle</span>";
                            logoChild.classList.add("logo-need-bottom");
                            italicEl.appendChild(logoChild);
                            let logoChild1 = document.createElement("div");
                            logoChild1.innerHTML = "<span>circle</span>";
                            logoChild1.classList.add("logo-need-top");
                            italicEl.appendChild(logoChild1);
                            if (dailyEvents > 1) {
                                italicEl.removeChild(leftChild);
                                italicEl.removeChild(logoChild);
                                logoChild1.classList.remove("logo-need-top");
                                logoChild1.classList.add("logo-need-top-fourweek");
                            }
                        }
                        if (dailyEvents > 1) {
                            italicEl.removeChild(descriptionChild);
                            if(ispremiumLaborLevelIconVisible){
                                italicEl.removeChild(premiumLaborLevelIcon);
                            }
                            child.classList.remove("openNeed-title");
                            if(arg.event.extendedProps.schedStatus == 'Posted' && arg.event.extendedProps.types.includes("Need"))
                            child.classList.add("openNeed-title-withschedule");
                            else
                             child.classList.add("openNeed-title-fourweek");
                        }

                        if (arg.event.extendedProps.filteredEventCount == 1 || arg.event.extendedProps.isAllFilterChecked == false) {
                            italicEl.appendChild(descriptionChild);
                            if(ispremiumLaborLevelIconVisible){
                                italicEl.appendChild(premiumLaborLevelIcon);
                            }
                            child.classList.add("openNeed-title");
                            child.classList.remove("openNeed-title-fourweek");
                        }
                    }
                    else if (!arg.event.extendedProps.needFV && dailyEvents <= 1) {
                        italicEl.classList.add("open-daycell");
                    }
                    else if(!arg.event.extendedProps.needFV && dailyEvents > 1){
                        arg.event.setProp("display", "none");
                    }
                }
                else if (arg.event.extendedProps.type.includes("Pending")) {
                    let descriptionCoid = document.createElement("div");
                    descriptionCoid.innerHTML = arg.event.extendedProps.descriptionCoid;
                    descriptionCoid.classList.add("event-descriptionCoid");
                    descriptionCoid.classList.add("hideFacilityDeptNumber");
                    let facilityDeptNameText = document.createElement("div");
                    facilityDeptNameText.innerHTML = arg.event.extendedProps.facilityDeptName;
                    facilityDeptNameText.classList.add("event-descriptionCoid");
                    facilityDeptNameText.classList.add("calDetailsPrint");
                    italicEl.appendChild(descriptionCoid);
                    italicEl.appendChild(facilityDeptNameText);
                    tippy(descriptionCoid, {
                        content: arg.event.extendedProps.facilityDeptName,
                        placement: 'bottom',
                    });
                    let descriptionChild = document.createElement("div");
                    descriptionChild.innerHTML = arg.event.extendedProps.description;
                    descriptionChild.classList.add("event-description");
                    descriptionChild.classList.add("mTop10");
                    italicEl.appendChild(descriptionChild);
                    italicEl.classList.add("main-reserve");
                    child.classList.add("reserveNeed-title");
                    child.innerHTML = arg.event.extendedProps.isOvertime ? '<i class="material-icons overtimeIndicatorDivSingleEvents">error_outline</i> ' + arg.event.title : arg.event.title;
                    const childElementTippy = tippy(child);
                    childElementTippy.disable();
                    if (dailyEvents > 1) {
                        child.classList.remove("reserveNeed-title");
                        child.classList.add("reserveNeed-title-fourweek");
                        child.innerHTML = arg.event.extendedProps.isOvertime ? '<i class="material-icons overtimeIndicatorDivMultipleEvents">error_outline</i> ' + arg.event.title : arg.event.title;
                        italicEl.removeChild(descriptionCoid);
                        italicEl.removeChild(facilityDeptNameText);
                        italicEl.removeChild(descriptionChild);
                        childElementTippy.setProps({ content: "<div style='text-align: center'>"+arg.event.extendedProps.facilityDeptName+"<br>" + arg.event.extendedProps.description+"</div>"});
                        childElementTippy.setProps({ placement: 'bottom'});
                        childElementTippy.setProps({ allowHTML: true});
                        childElementTippy.enable();
                    }

                    if (arg.event.extendedProps.filteredEventCount == 1 || arg.event.extendedProps.isAllFilterChecked == false) {
                        child.classList.add("reserveNeed-title");
                        child.classList.remove("reserveNeed-title-fourweek");
                        child.innerHTML = arg.event.extendedProps.isOvertime ? '<i class="material-icons overtimeIndicatorDivSingleEvents">error_outline</i> ' + arg.event.title : arg.event.title;
                        italicEl.appendChild(descriptionCoid);
                        italicEl.appendChild(facilityDeptNameText);
                        italicEl.appendChild(descriptionChild);
                        childElementTippy.disable();
                    }
                } else if (arg.event.extendedProps.type.includes("Request") || (arg.event.extendedProps.type == "Assignment" && arg.event.extendedProps.status == "Pending")) {
                    let descriptionCoid = document.createElement("div");
                    descriptionCoid.innerHTML = arg.event.extendedProps.descriptionCoid;
                    descriptionCoid.classList.add("event-descriptionCoid");
                    descriptionCoid.classList.add("hideFacilityDeptNumber");
                    let facilityDeptNameText = document.createElement("div");
                    facilityDeptNameText.innerHTML = arg.event.extendedProps.facilityDeptName;
                    facilityDeptNameText.classList.add("event-descriptionCoid");
                    facilityDeptNameText.classList.add("calDetailsPrint");
                    italicEl.appendChild(descriptionCoid);
                    italicEl.appendChild(facilityDeptNameText);
                    tippy(descriptionCoid, {
                        content: arg.event.extendedProps.facilityDeptName,
                        placement: 'bottom',
                    });
                    let descriptionChild = document.createElement("div");
                    descriptionChild.innerHTML = arg.event.extendedProps.description;
                    descriptionChild.classList.add("event-description");
                    descriptionChild.classList.add("mTop10");
                    italicEl.appendChild(descriptionChild);
                    italicEl.classList.add("main-reserve");
                    child.classList.add("requestNeed-title");
                    child.innerHTML = arg.event.extendedProps.isOvertime ? '<i class="material-icons overtimeIndicatorDivSingleEvents">error_outline</i> ' + arg.event.title : arg.event.title;
                    const childElementTippy = tippy(child);
                    childElementTippy.disable();
                    if (dailyEvents > 1) {
                        child.classList.remove("requestNeed-title");
                        child.classList.add("requestNeed-title-fourweek");
                        child.innerHTML = arg.event.extendedProps.isOvertime ? '<i class="material-icons overtimeIndicatorDivMultipleEvents">error_outline</i> ' + arg.event.title : arg.event.title;
                        italicEl.removeChild(descriptionCoid);
                        italicEl.removeChild(facilityDeptNameText);
                        italicEl.removeChild(descriptionChild);
                        childElementTippy.setProps({ content: "<div style='text-align: center'>"+arg.event.extendedProps.facilityDeptName+"<br>" + arg.event.extendedProps.description+"</div>"});
                        childElementTippy.setProps({ placement: 'bottom'});
                        childElementTippy.setProps({ allowHTML: true});
                        childElementTippy.enable();
                    }

                    if (arg.event.extendedProps.filteredEventCount == 1 || arg.event.extendedProps.isAllFilterChecked == false) {
                        child.classList.add("requestNeed-title");
                        child.classList.remove("requestNeed-title-fourweek");
                        child.innerHTML = arg.event.extendedProps.isOvertime ? '<i class="material-icons overtimeIndicatorDivSingleEvents">error_outline</i> ' + arg.event.title : arg.event.title;
                        italicEl.appendChild(descriptionCoid);
                        italicEl.appendChild(facilityDeptNameText);
                        italicEl.appendChild(descriptionChild);
                        childElementTippy.disable();
                    }
                } else if (arg.event.extendedProps.type.includes("Unavailability")) {
                    italicEl.classList.add("main-unavail");
                    child.classList.add("unavail-title");
                    child.innerHTML = arg.event.title;
                    if (dailyEvents > 1) {
                        child.classList.remove("unavail-title");
                        child.classList.add("unavail-title-fourweek");
                    }

                    if (arg.event.extendedProps.filteredEventCount == 1 || arg.event.extendedProps.isAllFilterChecked == false) {
                        child.classList.remove("unavail-title-fourweek");
                        child.classList.add("unavail-title");
                    }
                } else if (arg.event.extendedProps.type.includes("Trade")) {
                    let descriptionCoid = document.createElement("div");
                    descriptionCoid.innerHTML = arg.event.extendedProps.descriptionCoid;
                    descriptionCoid.classList.add("event-descriptionCoid");
                    descriptionCoid.classList.add("hideFacilityDeptNumber");
                    let facilityDeptNameText = document.createElement("div");
                    facilityDeptNameText.innerHTML = arg.event.extendedProps.facilityDeptName;
                    facilityDeptNameText.classList.add("event-descriptionCoid");
                    facilityDeptNameText.classList.add("calDetailsPrint");
                    italicEl.appendChild(descriptionCoid);
                    italicEl.appendChild(facilityDeptNameText);
                    tippy(descriptionCoid, {
                        content: arg.event.extendedProps.facilityDeptName,
                        placement: 'bottom',
                    });
                    let descriptionChild = document.createElement("div");
                    descriptionChild.classList.add("trade-description");
                    descriptionChild.classList.add("mTop10");
                    descriptionChild.innerHTML = arg.event.extendedProps.description;
                    italicEl.appendChild(descriptionChild);
                    italicEl.classList.add("main-trade");
                    child.classList.add("trade-title");
                    child.innerHTML = arg.event.title;
                    let leftChild = document.createElement("div");
                    leftChild.innerHTML = "TRADE PENDING";
                    leftChild.classList.add("trade-visual");
                    italicEl.appendChild(leftChild);
                    let logoChild = document.createElement("div");
                    logoChild.innerHTML = "<span>swap_horiz</span>";
                    logoChild.classList.add("logo-trade-bottom");
                    italicEl.appendChild(logoChild);
                    let logoChild1 = document.createElement("div");
                    logoChild1.innerHTML = "<span>swap_horiz</span>";
                    logoChild1.classList.add("logo-trade-top");
                    italicEl.appendChild(logoChild1);
                    const childElementTippy = tippy(child);
                    childElementTippy.disable();
                    if (dailyEvents > 1) {
                        italicEl.removeChild(leftChild);
                        italicEl.removeChild(logoChild);
                        italicEl.removeChild(descriptionCoid);
                        italicEl.removeChild(facilityDeptNameText);
                        italicEl.removeChild(descriptionChild);
                        child.classList.remove("trade-title");
                        child.classList.add("trade-title-fourweek");
                        logoChild1.classList.remove("logo-trade-top");
                        logoChild1.classList.add("logo-trade-top-fourweek");

                        childElementTippy.setProps({ content: "<div style='text-align: center'>"+arg.event.extendedProps.facilityDeptName+"<br>" + arg.event.extendedProps.description+"</div>"});
                        childElementTippy.setProps({ placement: 'bottom'});
                        childElementTippy.setProps({ allowHTML: true});
                        childElementTippy.enable();
                    }

                    if (arg.event.extendedProps.filteredEventCount == 1 || arg.event.extendedProps.isAllFilterChecked == false) {
                        italicEl.appendChild(leftChild);
                        italicEl.appendChild(logoChild);
                        italicEl.appendChild(descriptionCoid);
                        italicEl.appendChild(facilityDeptNameText);
                        italicEl.appendChild(descriptionChild);
                        child.classList.add("trade-title");
                        child.classList.remove("trade-title-fourweek");
                        logoChild1.classList.add("logo-trade-top");
                        logoChild1.classList.remove("logo-trade-top-fourweek");
                        childElementTippy.disable();
                    }
                } else {
                    let descriptionCoid = document.createElement("div");
                    descriptionCoid.innerHTML = arg.event.extendedProps.descriptionCoid;
                    descriptionCoid.classList.add("event-descriptionCoid");
                    descriptionCoid.classList.add("hideFacilityDeptNumber");
                    let facilityDeptNameText = document.createElement("div");
                    facilityDeptNameText.innerHTML = arg.event.extendedProps.facilityDeptName;
                    facilityDeptNameText.classList.add("event-descriptionCoid");
                    facilityDeptNameText.classList.add("calDetailsPrint");
                    italicEl.appendChild(descriptionCoid);
                    italicEl.appendChild(facilityDeptNameText);
                    tippy(descriptionCoid, {
                        content: arg.event.extendedProps.facilityDeptName,
                        placement: 'bottom',
                    });
                    let descriptionChild = document.createElement("div");
                    descriptionChild.innerHTML = arg.event.extendedProps.description;
                    descriptionChild.classList.add("event-description");
                    descriptionChild.classList.add("mTop10");
                    italicEl.appendChild(descriptionChild);
                    //Remove title in case of needs available
                     if (dailyEvents > 1 && arg.event.extendedProps.schedStatus =='Posted' && arg.event.extendedProps.types.includes("Need")) {
                        child.innerHTML = arg.event.extendedProps.isOvertime ? '<i class="material-icons overtimeIndicatorDivSingleEvents">error_outline</i> ':'';
                     }
                    else {
                         child.innerHTML = arg.event.extendedProps.isOvertime ? '<i class="material-icons overtimeIndicatorDivSingleEvents">error_outline</i> ' + arg.event.title : arg.event.title;
                         child.classList.add("event-title");
                        }
                    italicEl.classList.add("main-event");                    
                    const childElementTippy = tippy(child);
                    childElementTippy.disable();
                    if (eventChanged) {
                        let leftChild = document.createElement("div");
                        leftChild.innerHTML = "UPDATED";
                        leftChild.classList.add("event-updated");
                        italicEl.appendChild(leftChild);
                        let logoChild = document.createElement("div");
                        logoChild.innerHTML = "<span>circle</span>";
                        logoChild.classList.add("logo-updated-bottom");
                        italicEl.appendChild(logoChild);
                        let logoChild1 = document.createElement("div");
                        logoChild1.innerHTML = "<span>circle</span>";
                        logoChild1.classList.add("logo-updated-top");
                        italicEl.appendChild(logoChild1);
                        if (dailyEvents > 1) {
                            italicEl.removeChild(leftChild);
                            italicEl.removeChild(logoChild);
                            logoChild1.classList.remove("logo-updated-top");
                            logoChild1.classList.add("logo-updated-top-fourweek");
                        }
                    }
                   if (dailyEvents > 1 && arg.event.extendedProps.schedStatus =='Posted' && !arg.event.extendedProps.types.includes("Need") ) {
                        italicEl.removeChild(descriptionCoid);
                        italicEl.removeChild(descriptionChild);
                        italicEl.removeChild(facilityDeptNameText);
                        // child.classList.remove("event-title");
                        child.classList.add("event-title-fourweek");
                        child.innerHTML = arg.event.extendedProps.isOvertime ? '<i class="material-icons overtimeIndicatorDivMultipleEvents">error_outline</i> ' + arg.event.title : arg.event.title;
                        childElementTippy.setProps({ content: "<div style='text-align: center'>"+arg.event.extendedProps.facilityDeptName+"<br>" + arg.event.extendedProps.description+"</div>"});
                        childElementTippy.setProps({ placement: 'bottom'});
                        childElementTippy.setProps({ allowHTML: true});
                        childElementTippy.enable();
                   }
                    if (dailyEvents > 1 && arg.event.extendedProps.schedStatus !='Posted') {
                        italicEl.removeChild(descriptionCoid);
                        italicEl.removeChild(descriptionChild);
                        italicEl.removeChild(facilityDeptNameText);
                        child.classList.remove("event-title");
                        child.classList.add("event-title-fourweek");
                        child.innerHTML = arg.event.extendedProps.isOvertime ? '<i class="material-icons overtimeIndicatorDivMultipleEvents">error_outline</i> ' + arg.event.title : arg.event.title;
                        childElementTippy.setProps({ content: "<div style='text-align: center'>"+arg.event.extendedProps.facilityDeptName+"<br>" + arg.event.extendedProps.description+"</div>"});
                        childElementTippy.setProps({ placement: 'bottom'});
                        childElementTippy.setProps({ allowHTML: true});
                        childElementTippy.enable();
                    }
                   
                    if (arg.event.extendedProps.filteredEventCount == 1 || arg.event.extendedProps.isAllFilterChecked == false) {
                        child.classList.add("event-title");
                        child.classList.remove("event-title-fourweek");
                        child.innerHTML = arg.event.extendedProps.isOvertime ? '<i class="material-icons overtimeIndicatorDivSingleEvents">error_outline</i> ' + arg.event.title : arg.event.title;
                        italicEl.appendChild(descriptionCoid);
                        italicEl.appendChild(descriptionChild);
                        italicEl.appendChild(facilityDeptNameText);
                        childElementTippy.disable();
                    }
                }
                let arrayOfDomNodes = [italicEl];
                return {
                    domNodes: arrayOfDomNodes,
                };
            },
        };
        @schedule.State
        public userSchedules!: any;
        @schedule.State
        private isLoading!: Boolean;
        public events: any = [];
        private sharedToggle: boolean = false;
        public counter: any = 0;

        constructor() {
            super();
            //get singal r notification by using event bus
            bus.$on("profileLoaded", (msg) => {
                this.getTrainingVideos();                
                this.getSchedules(true);
            
                this.showWelcomeModal();
            });

            bus.$on("assignmentchanged", (msg) => {
                this.getSchedules(false);
            });

            bus.$on("loadShiftTradeEvent", (actionableByDate, shiftTradeOfferId) => {
                this.raiseShiftTradeViewEvent(actionableByDate, shiftTradeOfferId);
            });

            bus.$on("ShiftTradeActionEvent", (actionableByDate, action, shiftTradeOfferId, notificationId) => {
                let eventDate = new Date(actionableByDate);
                this.raiseShiftTradeActionEvent(eventDate, action, shiftTradeOfferId, notificationId);
            });
        }

        async created() {            
                if(this.profileData.username !== undefined)
                {
                    if (localStorage.getItem("visitedDepartmentView") != null) {
                        localStorage.removeItem("visitedDepartmentView");
                        await this.getSchedules(false);
                    }
                    else {
                        await this.getSchedules(true);
                    }
                }           
        }

        mounted() {
            this.updateUserName();
        }

        @Watch("viewFlag") async onViewChange() {
            if(this.viewFlag =='CalView'){
                await this.getSchedules(false);
            }
        }
        routetoAdmin(){
            if(this.profileData.isAdmin && !this.isImpersonating && !this.profileData.isStaffHasAdminAccount){
                const path = '/admin'
                if(this.$route.path !== path){
                    this.$router.push('/admin')
                }
            }
        }
        updated() {           
            if(this.profileData.isAdmin !== undefined)
            {
                this.routetoAdmin()
            }
            this.updateUserName();

            if(!this.isCalenderViewLoaded && this.appInsightEventData.Username != undefined){
                //User logged in Event
                var isUserLoggedIn = (localStorage.getItem("isUserLoggedIn") == null ? false : localStorage.getItem("isUserLoggedIn")=='true');
                
                if(isUserLoggedIn){
                    localStorage.removeItem("isUserLoggedIn");
                }

                //Calendar Load event
                this.isCalenderViewLoaded = true;
            }
        }

        closeSharedModal() {
            this.sharedToggle = false;
            if (
                this.sharedRequest.assignmentDetail ||
                this.sharedRequest.selfSchedule ||
                this.sharedRequest.availability ||
                this.sharedRequest.tradeShift ||
                this.sharedRequest.request ||
                this.sharedRequest.type === 3
            ) {
                this.getSchedules(false);
            }
            setTimeout(() => this.currentMonthCalendarApi.updateSize(), 300);
            window.scrollTo(0, 0);
        }

        refreshCalender() {
            this.getSchedules(false);
        }

        showSMPModal(successFlag: boolean = true, msgValue: string = '') {
            if (msgValue != '') {
                this.msgValue = successFlag ? msgValue : "Failed to save your changes";
            }
            else {
                this.msgValue = successFlag ? "Your changes have been saved." : "Failed to save your changes";
            }
            this.classFlag = successFlag ? "success" : "error";
            this.isSMPModalVisible = true;
        }

        closeSMPModal() {
            this.isSMPModalVisible = false;
        }

        showNotificationSuccessModal(options) {
            if (options.msgValue != '') {
                this.successMsgValue = options.msgValue;
            }
            else {
                this.successMsgValue = options.successFlag ? "Your changes have been saved." : "Failed to save your changes";
            }
            this.successClassFlag = options.successFlag ? "success" : "error";
            this.isNotificationSuccessModalVisible = true;
        }

        closeNotificationSuccessModal() {
            this.isNotificationSuccessModalVisible = false;
        }

        showNotificationErrorModal(options) {
            if (options.msgValue != '') {
                this.errorMsgValue = options.msgValue;
            }
            else {
                this.errorMsgValue = options.successFlag ? "Your changes have been saved." : "Failed to save your changes";
            }
            this.errorClassFlag = options.successFlag ? "success" : "error";
            this.isNotificationErrorModalVisible = true;
        }

        closeNotificationErrorModal() {
            this.isNotificationErrorModalVisible = false;
        }

        updateUserName() {
            if (this.profileData != null) {
                this.firstName = this.profileData.first;
                this.lastName = this.profileData.last;
            } else {
                this.firstName = this.oidcUser.firstName;
                this.lastName = this.oidcUser.firstName;
            }
            if (this.firstName != undefined && this.lastName != undefined) {
                this.nameInitials = this.firstName.charAt(0).toUpperCase() + this.lastName.charAt(0).toUpperCase();
            }
        }

        setCalendarEvents(index: number) {
             this.hasSelfScheduleNeedsInPrimaryDept = false;
            this.events = [];
            this.allocatedHours = 0;
            if (this.viewFlag == 'CalView') {
                this.currentMonthCalendarApi.removeAllEvents();
            }
            this.scheduleStatus = this.userSchedules[index].status;
            this.isSelfScheduleAllowed = this.profileData.selfSchedule;
            this.isTierOpen = this.userSchedules[index].tierOpen;
            this.currentDate =
                moment(this.userSchedules[index].startDate).format("ll") +
                " - " +
                moment(this.userSchedules[index].endDate).format("ll");
            let count = index + 1;

            if(this.scheduleStatus == "Plan Sheet")
            {
                this.defaultSelfScheduleState = this.userSchedules[index].defaultSelfScheduleState;
            }

            while (count >= index - 1) {
                if (this.userSchedules[count] != undefined) {
                     this.userSchedules[count].events.forEach((event: Event) => {
                        let cellTitle: string;
                        event.assignmentId =
                            event.type == "Need" || event.type == "Pending"
                                ? this.userSchedules[count].id
                                : "";
                        this.events.push(event);

                        cellTitle = this.getEventCellTitle(event, this.userSchedules[count].status, this.userSchedules[count].events);
                        if (this.viewFlag == 'CalView') {
                            this.currentMonthCalendarApi.addEvent({
                                id: event.id,
                                title: cellTitle,
                                start: event.date,
                                end: event.date,
                                type: event.type,
                                changed: event.changed,
                                status: event.status,
                                description: event.description,
                                descriptionCoid: event.status.toUpperCase() == "PENDING" || event.status.toUpperCase() == "SCHEDULED" || event.status.toUpperCase() == "RESERVED" ? (event.facilityCoId + ' - ' + event.departmentCode)
                                    : (this.userSchedules[count].coid + ' - ' + this.userSchedules[count].departmentCode),
                                facilityDeptName: event.status.toUpperCase() == "PENDING" || event.status.toUpperCase() == "SCHEDULED" || event.status.toUpperCase() == "RESERVED" ? (event.facilityName + ' - ' + event.departmentName)
                                    : (this.userSchedules[count].facilityName + ' - ' + this.userSchedules[count].departmentName),
                                dailyEvents: event.dailyEvents,
                                needFV: this.needFV,
                                filteredEventCount: 0,
                                isAllFilterChecked: true,
                                isSelfScheduled: event.isSelfScheduled,
                                isOvertime: event.isOvertime,
                                premiumLaborLevel: event.premiumLaborLevel,
                                schedStatus: this.scheduleStatus,
                                types: event.dailyEventsType
                            });
                        }
                    });
                }
                count -= 1;
            }

            //--Calcuate Commitment Submit Details in UI
            if (this.isSelfScheduleAllowed) {
                this.calenderStartforCSD = new Date(
                    this.userSchedules[index].startDate
                );
                 //check home dept self schedule needs
                 if(this.scheduleStatus.toUpperCase() == 'PLAN SHEET')
                 {
                    this.checkHomeDeptNeeds();
                 }
                this.scheduleId = this.userSchedules[index].id;
                this.getCommitmentSubmitDetails();
            }
            if (this.viewFlag == 'CalView') {
                if (this.leftNavBar) {
                    if (!this.$refs.calendarfilter.checkSchedEventsOption) {
                        this.onCheckSchedEvents(
                            this.$refs.calendarfilter.checkSchedEventsOption
                        );
                    }
                    if (!this.$refs.calendarfilter.checkPendRequestsOption) {
                        this.onCheckPendRequestsOption(
                            this.$refs.calendarfilter.checkPendRequestsOption
                        );
                    }
                    if (!this.$refs.calendarfilter.checkDepartNeedsOption) {
                        this.onCheckDepartNeedsOption(
                            this.$refs.calendarfilter.checkDepartNeedsOption
                        );
                    }
                    if (!this.$refs.calendarfilter.checkTradeShiftsOption) {
                        this.onCheckTradeShiftsOption(
                            this.$refs.calendarfilter.checkTradeShiftsOption
                        );
                    }
                    if (!this.$refs.calendarfilter.checkUnavailabilityOption) {
                        this.onCheckUnavailabilityOption(
                            this.$refs.calendarfilter.checkUnavailabilityOption
                        );
                    }
                }
            }   
        }

        getEventCellTitle(event, status, events) {
            var cellTitle = '';
            if (event.type == "Need") {
                cellTitle = event.status.toUpperCase();
            } else if (event.type == "Pending") {
                cellTitle = "RESERVED";
            } else if (event.type == "Assignment" && event.status == "Pending" && status == "Plan Sheet" && event.isSelfScheduled) {
                cellTitle = "PENDING";
            } else if (event.type == "Request" || (event.type == "Assignment" && event.status == "Pending")) {
                cellTitle = "REQUESTED";
            } else if (event.type == "Unavailability") {
                cellTitle = "UNAVAILABLE";
            } else if (event.type == "Trade") {
                cellTitle = event.status.toUpperCase();
            }//event.type = "Assignment"
            else {
                cellTitle = "SCHEDULED";
            }
            return cellTitle;
        }

        toggleFilterPanel() {
            this.leftNavBar = !this.leftNavBar;
        }

        onCheckSchedEvents(check: boolean) {
            let events = this.currentMonthCalendarApi.getEvents();
            let filteredDatesRemoved: any = [];
            let filteredDatesAdded: any = [];
            let isAllFilterStatusUpdated: boolean = false;
            if (check) {
                events.forEach((event: any) => {
                    if (event.extendedProps.type == "Assignment" && event.extendedProps.status != "Pending") {
                        event.setProp("display", "auto");
                        filteredDatesAdded.push(event.start);
                        if(this.isAllFilterChecked == false && event.extendedProps.dailyEvents > 1){
                           event.setExtendedProp('isAllFilterChecked', false);
                           isAllFilterStatusUpdated = true;
                        }
                    }
                });
                if(isAllFilterStatusUpdated){
                    this.isAllFilterChecked = true;
                }
            } else if (!check) {
                events.forEach((event: any) => {
                    if (event.extendedProps.type == "Assignment" && event.extendedProps.status != "Pending") {
                        event.setProp("display", "none");
                        filteredDatesRemoved.push(event.start);
                    }
                });
            }

            if(filteredDatesRemoved.length > 0){
                filteredDatesRemoved.forEach((removedDate: any) => {
                    let startDate = moment(removedDate).format("YYYY-MM-DD");
                    events.forEach((event: any) => {
                        let eventDate = moment(event.start).format("YYYY-MM-DD");
                        if ((event.extendedProps.type != "Assignment" || (event.extendedProps.type == "Assignment" && event.extendedProps.status == "Pending")) && startDate == eventDate) {
                            let count = event.extendedProps.filteredEventCount == 0 ? event.extendedProps.dailyEvents - 1 : event.extendedProps.filteredEventCount - 1;
                            event.setExtendedProp('filteredEventCount', count);
                            event.setExtendedProp('isAllFilterChecked', true);
                        }
                    });
                });
            }

            if(filteredDatesAdded.length > 0){
                filteredDatesAdded.forEach((addedDate: any) => {
                    let startDate = moment(addedDate).format("YYYY-MM-DD");
                    events.forEach((event: any) => {
                        let eventDate = moment(event.start).format("YYYY-MM-DD");
                        if ((event.extendedProps.type != "Assignment" || (event.extendedProps.type == "Assignment" && event.extendedProps.status == "Pending")) && startDate == eventDate) {
                            let count = event.extendedProps.filteredEventCount == 0 ? event.extendedProps.dailyEvents : event.extendedProps.filteredEventCount + 1;
                            event.setExtendedProp('filteredEventCount', count);
                            event.setExtendedProp('isAllFilterChecked', true);
                        }
                    });
                });
            }
        }

        onCheckPendRequestsOption(check: boolean) {
            let events = this.currentMonthCalendarApi.getEvents();
            let filteredDatesRemoved: any = [];
            let filteredDatesAdded: any = [];
            let isAllFilterStatusUpdated: boolean = false;
            if (check) {
                events.forEach((event: any) => {
                    if (
                        event.extendedProps.type == "Pending" ||
                        event.extendedProps.type == "Request" || (event.extendedProps.type == "Assignment" && event.extendedProps.status == "Pending")
                    ) {
                        event.setProp("display", "auto");
                        filteredDatesAdded.push(event.start);
                        if(this.isAllFilterChecked == false && event.extendedProps.dailyEvents > 1){
                           event.setExtendedProp('isAllFilterChecked', false);
                           isAllFilterStatusUpdated = true;
                        }
                    }
                });
                if(isAllFilterStatusUpdated){
                    this.isAllFilterChecked = true;
                }
            } else if (!check) {
                events.forEach((event: any) => {
                    if (
                        event.extendedProps.type == "Pending" ||
                        event.extendedProps.type == "Request" || (event.extendedProps.type == "Assignment" && event.extendedProps.status == "Pending")
                    ) {
                        event.setProp("display", "none");
                        filteredDatesRemoved.push(event.start);
                    }
                });
            }

            if(filteredDatesRemoved.length > 0){
                filteredDatesRemoved.forEach((removedDate: any) => {
                    let startDate = moment(removedDate).format("YYYY-MM-DD");
                    events.forEach((event: any) => {
                        let eventDate = moment(event.start).format("YYYY-MM-DD");
                        if ((event.extendedProps.type != "Pending" ||
                        event.extendedProps.type != "Request" || (event.extendedProps.type != "Assignment" && event.extendedProps.status != "Pending")) && startDate == eventDate) {
                            let count = event.extendedProps.filteredEventCount == 0 ? event.extendedProps.dailyEvents - 1 : event.extendedProps.filteredEventCount - 1;
                            event.setExtendedProp('filteredEventCount', count);
                            event.setExtendedProp('isAllFilterChecked', true);
                        }
                    });
                });
            }

            if(filteredDatesAdded.length > 0){
                filteredDatesAdded.forEach((addedDate: any) => {
                    let startDate = moment(addedDate).format("YYYY-MM-DD");
                    events.forEach((event: any) => {
                        let eventDate = moment(event.start).format("YYYY-MM-DD");
                        if ((event.extendedProps.type != "Pending" ||
                        event.extendedProps.type != "Request" || (event.extendedProps.type != "Assignment" && event.extendedProps.status != "Pending")) && startDate == eventDate) {
                            let count = event.extendedProps.filteredEventCount == 0 ? event.extendedProps.dailyEvents : event.extendedProps.filteredEventCount + 1;
                            event.setExtendedProp('filteredEventCount', count);
                            event.setExtendedProp('isAllFilterChecked', true);
                        }
                    });
                });
            }
        }

        onCheckDepartNeedsOption(check: boolean) {
            let events = this.currentMonthCalendarApi.getEvents();
            let filteredDatesRemoved: any = [];
            let filteredDatesAdded: any = [];
            let isAllFilterStatusUpdated: boolean = false;
            if (check) {
                events.forEach((event: any) => {
                    if (event.extendedProps.type == "Need") {
                        event.setExtendedProp('needFV', true);
                        this.isDeptNeedCheck = true;
                        event.setProp("display", "auto");
                        filteredDatesAdded.push(event.start);
                        if(this.isAllFilterChecked == false && event.extendedProps.dailyEvents > 1){
                           event.setExtendedProp('isAllFilterChecked', false);
                           isAllFilterStatusUpdated = true;
                        }
                    }
                });
                if(isAllFilterStatusUpdated){
                    this.isAllFilterChecked = true;
                }
            } else if (!check) {
                events.forEach((event: any) => {
                    if (event.extendedProps.type == "Need") {
                        event.setExtendedProp('needFV', false);
                        this.isDeptNeedCheck = false;
                        filteredDatesRemoved.push(event.start);
                    }
                });
            }

            if(filteredDatesRemoved.length > 0){
                filteredDatesRemoved.forEach((removedDate: any) => {
                    let startDate = moment(removedDate).format("YYYY-MM-DD");
                    events.forEach((event: any) => {
                        let eventDate = moment(event.start).format("YYYY-MM-DD");
                        if (event.extendedProps.type != "Need" && startDate == eventDate) {
                            let count = event.extendedProps.filteredEventCount == 0 ? event.extendedProps.dailyEvents - 1 : event.extendedProps.filteredEventCount - 1;
                            event.setExtendedProp('filteredEventCount', count);
                            event.setExtendedProp('isAllFilterChecked', true);
                        }
                    });
                });
            }

            if(filteredDatesAdded.length > 0){
                filteredDatesAdded.forEach((addedDate: any) => {
                    let startDate = moment(addedDate).format("YYYY-MM-DD");
                    events.forEach((event: any) => {
                        let eventDate = moment(event.start).format("YYYY-MM-DD");
                        if (event.extendedProps.type != "Need" && startDate == eventDate) {
                            let count = event.extendedProps.filteredEventCount == 0 ? event.extendedProps.dailyEvents : event.extendedProps.filteredEventCount + 1;
                            event.setExtendedProp('filteredEventCount', count);
                            event.setExtendedProp('isAllFilterChecked', true);
                        }
                    });
                });
            }
        }

        onCheckTradeShiftsOption(check: boolean) {
            let events = this.currentMonthCalendarApi.getEvents();
            let filteredDatesRemoved: any = [];
            let filteredDatesAdded: any = [];
            let isAllFilterStatusUpdated: boolean = false;
            if (check) {
                events.forEach((event: any) => {
                    if (event.extendedProps.type == "Trade") {
                        event.setProp("display", "auto");
                        filteredDatesAdded.push(event.start);
                        if(this.isAllFilterChecked == false && event.extendedProps.dailyEvents > 1){
                           event.setExtendedProp('isAllFilterChecked', false);
                           isAllFilterStatusUpdated = true;
                        }
                    }
                });
                if(isAllFilterStatusUpdated){
                    this.isAllFilterChecked = true;
                }
            } else if (!check) {
                events.forEach((event: any) => {
                    if (event.extendedProps.type == "Trade") {
                        event.setProp("display", "none");
                        filteredDatesRemoved.push(event.start);
                    }
                });
            }

            if(filteredDatesRemoved.length > 0){
                filteredDatesRemoved.forEach((removedDate: any) => {
                    let startDate = moment(removedDate).format("YYYY-MM-DD");
                    events.forEach((event: any) => {
                        let eventDate = moment(event.start).format("YYYY-MM-DD");
                        if (event.extendedProps.type != "Trade" && startDate == eventDate) {
                            let count = event.extendedProps.filteredEventCount == 0 ? event.extendedProps.dailyEvents - 1 : event.extendedProps.filteredEventCount - 1;
                            event.setExtendedProp('filteredEventCount', count);
                            event.setExtendedProp('isAllFilterChecked', true);
                        }
                    });
                });
            }

            if(filteredDatesAdded.length > 0){
                filteredDatesAdded.forEach((addedDate: any) => {
                    let startDate = moment(addedDate).format("YYYY-MM-DD");
                    events.forEach((event: any) => {
                        let eventDate = moment(event.start).format("YYYY-MM-DD");
                        if (event.extendedProps.type != "Trade" && startDate == eventDate) {
                            let count = event.extendedProps.filteredEventCount == 0 ? event.extendedProps.dailyEvents : event.extendedProps.filteredEventCount + 1;
                            event.setExtendedProp('filteredEventCount', count);
                            event.setExtendedProp('isAllFilterChecked', true);
                        }
                    });
                });
            }
        }

        onCheckAllOption(check: boolean) {
            let events = this.currentMonthCalendarApi.getEvents();
            if (check) {
                events.forEach((event: any) => {
                    if (
                        event.extendedProps.type == "Assignment" ||
                        event.extendedProps.type == "Pending" ||
                        event.extendedProps.type == "Trade" ||
                        event.extendedProps.type == "Unavailability" ||
                        event.extendedProps.type == "Request" ||
                        (event.extendedProps.type == "Assignment" && event.extendedProps.status == "Pending")
                    ) {
                        event.setProp("display", "auto");
                    }
                    if (event.extendedProps.type == "Need") {
                        event.setExtendedProp('needFV', true);
                        event.setProp("display", "auto");
                    }
                    event.setExtendedProp('filteredEventCount', 0);
                    this.isAllFilterChecked = true;
                    event.setExtendedProp('isAllFilterChecked', true);
                });
            } else if (!check) {
                events.forEach((event: any) => {
                    if (
                        event.extendedProps.type == "Assignment" ||
                        event.extendedProps.type == "Pending" ||
                        event.extendedProps.type == "Trade" ||
                        event.extendedProps.type == "Unavailability" ||
                        event.extendedProps.type == "Request" ||
                        (event.extendedProps.type == "Assignment" && event.extendedProps.status == "Pending")
                    ) {
                        event.setProp("display", "none");
                    }
                    if (event.extendedProps.type == "Need") {
                        event.setExtendedProp('needFV', false);
                    }
                    event.setExtendedProp('filteredEventCount', 0);
                    this.isAllFilterChecked = false;
                    event.setExtendedProp('isAllFilterChecked', true);
                });
            }
        }

        onCheckUnavailabilityOption(check: boolean) {
            let events = this.currentMonthCalendarApi.getEvents();
            let filteredDatesRemoved: any = [];
            let filteredDatesAdded: any = [];
            let isAllFilterStatusUpdated: boolean = false;
            if (check) {
                events.forEach((event: any) => {
                    if (event.extendedProps.type == "Unavailability") {
                        event.setProp("display", "auto");
                        filteredDatesAdded.push(event.start);
                        if(this.isAllFilterChecked == false && event.extendedProps.dailyEvents > 1){
                           event.setExtendedProp('isAllFilterChecked', false);
                           isAllFilterStatusUpdated = true;
                        }
                    }
                });

                if(isAllFilterStatusUpdated){
                    this.isAllFilterChecked = true;
                }
            } else if (!check) {
                events.forEach((event: any) => {
                    if (event.extendedProps.type == "Unavailability") {
                        event.setProp("display", "none");
                        filteredDatesRemoved.push(event.start);
                    }
                });
            }

            if(filteredDatesRemoved.length > 0){
                filteredDatesRemoved.forEach((removedDate: any) => {
                    let startDate = moment(removedDate).format("YYYY-MM-DD");
                    events.forEach((event: any) => {
                        let eventDate = moment(event.start).format("YYYY-MM-DD");
                        if (event.extendedProps.type != "Unavailability" && startDate == eventDate) {
                            let count = event.extendedProps.filteredEventCount == 0 ? event.extendedProps.dailyEvents - 1 : event.extendedProps.filteredEventCount - 1;
                            event.setExtendedProp('filteredEventCount', count);
                            event.setExtendedProp('isAllFilterChecked', true);
                        }
                    });
                });
            }

            if(filteredDatesAdded.length > 0){
                filteredDatesAdded.forEach((addedDate: any) => {
                    let startDate = moment(addedDate).format("YYYY-MM-DD");
                    events.forEach((event: any) => {
                        let eventDate = moment(event.start).format("YYYY-MM-DD");
                        if (event.extendedProps.type != "Unavailability" && startDate == eventDate) {
                            let count = event.extendedProps.filteredEventCount == 0 ? event.extendedProps.dailyEvents : event.extendedProps.filteredEventCount + 1;
                            event.setExtendedProp('filteredEventCount', count);
                            event.setExtendedProp('isAllFilterChecked', true);
                        }
                    });
                });
            }
        }

        async getTrainingVideos(){
            this.$store.dispatch('profile/getTrainingVideos');    
        }

        async getSchedules(currentDate: boolean = false) {
            if (currentDate) {
                localStorage.removeItem("sIndex");
                this.currentShceduleIndex = 0
            }
            
            if (localStorage.getItem("sIndex") != null) {
                this.currentShceduleIndex = Number(localStorage.getItem("sIndex"));
            } 
            
            this.isUnavailabilityAllowed = this.profileData.isUnavailabilityAllowed;
            this.guranteedHrs = this.profileData.guarenteedHours;
            this.otHrs = this.profileData.otHours;
            this.maxSelfScheduleHours = this.profileData.maxSelfScheduleHours;
            this.employeeType = this.profileData.employeeType;
            this.displayWSC =
                this.profileData.weekendShiftCommitment != 0 ? true : false;
            this.reqCountWSC = this.profileData.weekendShiftCommitment;
            this.weeksInSchedule = this.profileData.weeksInSchedule;

            let payload = {
                username: this.profileData.username,
                index: this.currentShceduleIndex,
            };
            if(this.profileData.staffId == 0)
            return;
            await this.$store
                .dispatch("schedule/getAllUserSchedules", payload)
                .then((res: any) => {
                    if (currentDate) {
                        let currSchedule = this.getCurrentWeekSchedule();
                        this.scheduleStatus = currSchedule.status;
                        if (this.viewFlag == 'CalView') {
                            this.currentMonthCalendarApi = this.$refs.fullCalendarCurrentMonth.getApi();
                            this.currentMonthCalendarApi.changeView("dayGrid"); //Switch to one day view
                            this.currentMonthCalendarApi.gotoDate(currSchedule.startDate);
                        }
                    }
                    else {
                        if (localStorage.getItem("sIndex") != null) {
                            var departmentScheduleIndex = Number(localStorage.getItem("sIndex"));
                            let currsched = this.userSchedules[departmentScheduleIndex];
                            this.currentShceduleIndex = departmentScheduleIndex;
                            this.scheduleStartDate = currsched.startDate;
                            this.scheduleEndDate = currsched.endDate;
                            this.scheduleStatus = currsched.status;
                            if (this.viewFlag == 'CalView') {
                                this.currentMonthCalendarApi = this.$refs.fullCalendarCurrentMonth.getApi();
                                this.currentMonthCalendarApi.changeView("dayGrid"); //Switch to one day view
                                this.currentMonthCalendarApi.gotoDate(currsched.startDate);
                            }
                        }
                    }

                    this.setCalendarEvents(this.currentShceduleIndex);
                    if (this.viewFlag == 'CalView') {
                        this.currentMonthCalendarApi.changeView("dayGrid");
                        this.currentMonthCalendarApi.setOption('duration', { weeks: this.weeksInSchedule });
                        this.currentMonthCalendarApi.setOption('dateIncrement', { weeks: this.weeksInSchedule });
                        if (this.weeksInSchedule == 6) {
                            this.currentMonthCalendarApi.setOption('height', 800);
                        }
                        else {
                            this.currentMonthCalendarApi.setOption('height', 550);
                        }
                    }
                })
                .catch((err: any) => {
                    if (err) {
                        console.log(err); // Handle errors any way you want
                    }
                });

            localStorage.setItem("sIndex", this.currentShceduleIndex.toString());
        }

        async getScheduleDetailsOnNavigation(index: Number): Promise<any> {
            let payload = {
                username: this.profileData.username,
                index: index,
            };

            await this.$store
                .dispatch("schedule/getAllUserSchedules", payload)
                .then((res: any) => {
                    return res.data;
                })
                .catch((err: any) => {
                    if (err) {
                        console.log(err); // Handle errors any way you want
                    }
                });
        }

        showModal() {
            this.sharedToggle = true;
            setTimeout(() => this.currentMonthCalendarApi.updateSize(), 300);
            window.scrollTo(0, 0);
        }

        handleDateUnselect(selectinfo: DateSelectArg) {
            if (
                selectinfo.jsEvent?.shiftKey == false &&
                this.selectedDates.length > 0
            ) {
                alert("Great");
            }
        }

        handleDateSelect(selectInfo: DateSelectArg, onDateNavigation: boolean = false) {
            let startDate = moment(selectInfo.start).format("YYYY-MM-DD");
            let objEndDate: Date = new Date(selectInfo.end);
            objEndDate.setDate(objEndDate.getDate() - 1);
            let endDate = moment(objEndDate).format("YYYY-MM-DD");
            let todayDate = moment(new Date()).format("YYYY-MM-DD");

            var startSD = moment(startDate, 'M/D/YYYY');
            var endSD = moment(endDate, 'M/D/YYYY');
            var diffDays = endSD.diff(startSD, 'days');

            if (
                new Date(startDate) <= new Date(todayDate) &&
                new Date(endDate) <= new Date(todayDate)
            ) {
                this.isUnavailabilityAllowed = false;
            } else {
                this.isUnavailabilityAllowed = this.profileData.isUnavailabilityAllowed;
            }

            this.calSelectedDates =  { startDate: selectInfo.start, endDate: selectInfo.end };

            this.sharedToggle = false;
            setTimeout(() => this.currentMonthCalendarApi.updateSize(), 300);
            var employeeEndDate = this.profileData.employeeEndDate;
            if ((employeeEndDate == null || moment(employeeEndDate) >= moment(selectInfo.end)) && (this.checkIfFutureDate(selectInfo.end) || onDateNavigation)) {
                var scheduleEventType: any;
                let selfScheduleDeptIds: any;
                const checkSchedules = this.userSchedules[this.currentShceduleIndex].events.some((schedules) => {
                    scheduleEventType = schedules.type;
                   if(scheduleEventType == "Need" && moment(schedules.date).format("YYYY-MM-DD") == moment(selectInfo.start).format("YYYY-MM-DD"))
                    {
                      selfScheduleDeptIds = schedules.selfScheduleDepartments;                      
                    }
                    return (moment(schedules.date).format("YYYY-MM-DD") == moment(selectInfo.start).format("YYYY-MM-DD")
                    );
                });
                if (checkSchedules) {
                    if ((scheduleEventType != "Need" && diffDays == 0) || (scheduleEventType == "Need" && diffDays == 0 && this.isDeptNeedCheck == false))
                        return;
                }
                this.sharedToggle = (this.isUnavailabilityAllowed || this.checkIfFutureDate(selectInfo.start) || onDateNavigation);
                this.counter = this.counter + 1;
                setTimeout(() => this.currentMonthCalendarApi.updateSize(), 300);
                window.scrollTo(0, 0);

                var isMultiDayAllowed = this.multiDaySelectionAllowedOrNot();
                const reset: any = [];
                this.currentEvent = reset;  
                this.sharedRequest = {
                    type: 1,
                    selfSchedule: isMultiDayAllowed,
                    request: this.checkIfFutureDate(selectInfo.start),
                    availability: this.isUnavailabilityAllowed,
                    vacationBidding: false,
                    calSelectedDates: this.calSelectedDates,
                    isSelfScheduledEvent: false,
                    status: this.scheduleStatus,
                    scheduleId: (isMultiDayAllowed == true ? this.userSchedules[this.currentShceduleIndex].id : ""),
                    SelfScheduleDepartments: selfScheduleDeptIds
                }; /*needApproval: true,*/
                if (new Date(selectInfo.start) < new Date(this.scheduleStartDate)) {
                    this.prevMonth();
                }
                else if (new Date(selectInfo.start) > new Date(this.scheduleEndDate)) {
                    this.nextMonth();
                }
            }
        }

        multiDaySelectionAllowedOrNot() {
            var returnVal;
            if (this.scheduleStatus.toUpperCase() == 'PLAN SHEET' && this.isTierOpen == true) {
                var startSD = moment(this.calSelectedDates.startDate, 'M/D/YYYY');
                var endSD = moment(this.calSelectedDates.endDate, 'M/D/YYYY');
                var diffDays = endSD.diff(startSD, 'days');
                let calCurrentDate: Date = new Date(this.calSelectedDates.startDate);
                let todayDate: Date = new Date();
                if (calCurrentDate < todayDate) {
                    calCurrentDate = todayDate;
                    let currentDiffDays = (moment(todayDate, 'M/D/YYYY')).diff(startSD, 'days');
                    diffDays = diffDays - currentDiffDays;
                }

                for (var i = 0; i < diffDays; i++) {
                    var isNeedExist = this.events.find(
                        (event: Event) =>
                            moment(event.date).format("YYYY-MM-DD") ==
                            moment(calCurrentDate).format("YYYY-MM-DD")
                            && event.type == "Need"
                    );
                    if (isNeedExist != undefined) {
                        returnVal = true;
                        calCurrentDate.setDate(calCurrentDate.getDate() + 1);
                    }
                    else {
                        returnVal = false;
                        break;
                    }
                }
            }
            else {
                returnVal = false;
            }
            return returnVal;
        }

        async raiseShiftTradeViewEvent(eventDate: any, shiftTradeOfferId: any)
        {
            var payload = { 
                username: this.profileData.username, 
                shiftTradeOfferId: shiftTradeOfferId,
            };

            this.$store.dispatch("schedule/getShiftTradeRequested", payload)
                .then((res: any) => {
                    if(res === '' || res.status === 'Accepted')
                    {
                        this.isAlertModalVisible = true;
                        this.alertMsgValue = 'This shift is no longer available for swapping.';
                    }
                    else
                    {
                        let date = new Date(res.date);
                        this.raiseShiftTradeViewClickEvent(date, res.id, null);
                    }
                })
                .catch((err: any) => {
                    if (err) {
                        console.log(err); // Handle errors any way you want
                    }
                });
        }

        async raiseShiftTradeActionEvent(eventDate: any, action: any, shiftTradeOfferId: any, notificationId: any) {
            var payload = { 
                username: this.profileData.username, 
                shiftTradeOfferId: shiftTradeOfferId,
            };

            this.$store.dispatch("schedule/getShiftTradeRequested", payload)
                .then((res: any) => {
                    if(res === '' || res.status === 'Accepted')
                    {
                        this.isAlertModalVisible = true;
                        this.alertMsgValue = 'This shift is no longer available for swapping.';
                    }
                    else
                    {
                        const requestBody = [{
                        id: shiftTradeOfferId,
                        username: res.username,
                        firstName: res.firstName,
                        lastName: res.lastName,
                        tenantId: res.tenantId,
                        scheduleId: res.scheduleId,
                        facilityId: res.facilityId,
                        coid: res.coid,
                        facilityName: res.facilityName,
                        departmentId: res.departmentId,
                        // facilityCoId: this.assignmentDetail.facilityCoId,
                        departmentName: res.departmentName,
                        departmentCode: res.departmentCode,
                        departmentShiftId: res.departmentShiftId, // todo not sure of value
                        shiftCode: res.shiftCode,
                        shiftDescription: res.shiftDescription,
                        skill: res.skill,
                        date: res.date,
                        startTime: res.startTime,
                        endTime: res.endTime,
                        actualStartTime: res.actualStartTime,
                        actualEndTime: res.actualEndTime,
                        hours: res.hours,
                        minutes: res.minutes,
                        status: "",
                        requestorAssignmentId: res.requestorAssignmentId,
                        acceptorAssignmentId: res.acceptorAssignmentId,
                        offeredToUsername: res.offeredToUsername,
                        offeredToFirstName: res.offeredToFirstName,
                        offeredToLastName: res.offeredToLastName,
                        isAutoapprovable: res.isAutoapprovable,
                        notificationId: notificationId
                    }];
                    requestBody[0].status = action === "Decline" ? 'Rejected' : 'Accepted';
                    this.isLoading = true;
                    this.$store
                        .dispatch("schedule/acceptShiftTradeOffer", requestBody)
                        .then(() => {
                            this.isLoading = false;
                            this.$emit('showSuccessMsgPopUp', true);
                            this.$emit('closeSharedModal');
                            bus.$emit('shiftTradenotificationchanged');
                            this.refreshCalender();
                        })
                        .catch((err: any) => {
                            this.isLoading = false;
                            this.$emit('showSuccessMsgPopUp', false);
                            let parseResponse = err.request.responseText != "" ? JSON.parse(err.request.responseText) : err.request.responseText;
                            this.isAlertModalVisible = true;
                            this.alertMsgValue = (parseResponse.result != null || parseResponse.result != undefined) ? JSON.parse(parseResponse.result).Message : "An error has occurred. Please try again. If the error persists, contact Facility Scheduler support.";
                            bus.$emit('shiftTradenotificationchanged');
                        });
                    }
                })
                .catch((err: any) => {
                    if (err) {
                        console.log(err); // Handle errors any way you want
                    }
                });
        }

        async raiseShiftTradeViewClickEvent(eventDate: any, shiftTradeOfferId: any, callback) {
            if (new Date(eventDate) < new Date(this.scheduleStartDate)) {
                await this.prevMonth();
            }
            else if (new Date(eventDate) > new Date(this.scheduleEndDate)) {
                await this.nextMonth();
            }
            this.updateData = eventDate;
            var eventFound = false;
            for (var i = 0; i < this.userSchedules.length; i++) {
                if (eventDate >= new Date(this.userSchedules[i].startDate) && eventDate <= new Date(this.userSchedules[i].endDate)) {
                    this.userSchedules[i].events.forEach((event: Event) => {
                        if (eventDate.toDateString() == new Date(event.date).toDateString()) {
                            var cellTitle = this.getEventCellTitle(event, this.userSchedules[i].status, this.userSchedules[i].events);
                            if(shiftTradeOfferId === event.id)
                                this.processClickEvent(cellTitle, eventDate, event.id, this.needFV);
                            eventFound = true;
                            return;
                        }
                    });
                }
            }
            if (!eventFound) {
                var selectInfo: DateSelectArg = {} as DateSelectArg;
                var endDate = new Date(eventDate);
                endDate.setDate(eventDate.getDate() + 1)
                selectInfo.start = eventDate;
                selectInfo.end = endDate;
                this.handleDateSelect(selectInfo, true);
            }
            if (callback) {
                callback(this.sharedRequest);
            }
        }

        async raiseClickEvent(eventDate: any, callback) {
            if (new Date(eventDate) < new Date(this.scheduleStartDate)) {
                await this.prevMonth();
            }
            else if (new Date(eventDate) > new Date(this.scheduleEndDate)) {
                await this.nextMonth();
            }
            this.updateData = eventDate;
            var eventFound = false;
            for (var i = 0; i < this.userSchedules.length; i++) {
                if (eventDate >= new Date(this.userSchedules[i].startDate) && eventDate <= new Date(this.userSchedules[i].endDate)) {
                    this.userSchedules[i].events.forEach((event: Event) => {
                        if (eventDate.toDateString() == new Date(event.date).toDateString()) {
                            var cellTitle = this.getEventCellTitle(event, this.userSchedules[i].status, this.userSchedules[i].events);
                            this.processClickEvent(cellTitle, eventDate, event.id, this.needFV);
                            eventFound = true;
                            return;
                        }
                    });
                }
            }
            if (!eventFound) {
                var selectInfo: DateSelectArg = {} as DateSelectArg;
                var endDate = new Date(eventDate);
                endDate.setDate(eventDate.getDate() + 1)
                selectInfo.start = eventDate;
                selectInfo.end = endDate;
                this.handleDateSelect(selectInfo, true);
            }
            if (callback) {
                callback(this.sharedRequest);
            }
        }

        handleEventClick(clickInfo: EventClickArg) {
            this.processClickEvent(clickInfo.event.title, clickInfo.event.start, clickInfo.event.id, clickInfo.event.extendedProps.needFV);
        }

        processClickEvent(cellTitle, eventStart, eventId, needFV) {
            const event = cellTitle.includes("NEEDS") || cellTitle.includes("SHIFT")
                ? this.events.find(
                    (event: Event) =>
                        moment(event.date).format("YYYY-MM-DD") ==
                        moment(eventStart).format("YYYY-MM-DD")
                        && event.type == "Need"
                )
                : this.events.find((event: Event) => event.id === eventId);
            var employeeEndDate = this.profileData.employeeEndDate;
            if (event && (employeeEndDate == null || employeeEndDate >= event.date)) {
                this.currentEvent = event;
                this.sharedToggle = false;
                this.sharedToggle = true;
                this.counter = this.counter + 1;
                setTimeout(() => this.currentMonthCalendarApi.updateSize(), 300);
                window.scrollTo(0, 0);
                if (
                    event.status == "Scheduled" &&
                    this.scheduleStatus == "Posted" && 
                    this.checkIfFutureDate(event.date)
                ) {
                    let strClickEventDate = moment(event.date).format("YYYY-MM-DD");
                    let clickEventNextDate: Date = new Date(moment(event.date).format("YYYY/MM/DD"));
                    clickEventNextDate.setDate(clickEventNextDate.getDate() + 1);
                    let todayDate = moment(new Date()).format("YYYY-MM-DD");

                    if (new Date(strClickEventDate) <= new Date(todayDate)) {
                        this.isUnavailabilityAllowed = false;
                    }
                    else {
                        this.isUnavailabilityAllowed = this.profileData.isUnavailabilityAllowed;
                    }
                    if (moment(event.actualStartTime) > moment().add(12,'hours')) {
                        this.isShiftTradeAllowed = true;
                    } else {
                        this.isShiftTradeAllowed = false;
                    }

                    this.calSelectedDates = { startDate: eventStart, endDate: clickEventNextDate };

                    this.sharedRequest = {
                        type: 4,
                        tradeShift: this.isShiftTradeAllowed,
                        selfSchedule: true,
                        request: this.checkIfFutureDate(strClickEventDate),
                        status: this.scheduleStatus,
                        calSelectedDates: this.calSelectedDates,
                        isSelfScheduledEvent: false,
                        assignmentDetail: !this.isShiftTradeAllowed,
                        isSymphonyUser: this.profileData.useMySchedulerOperatingRoom? true :false
                    };
                    return;
                }

                if (event.type == "Need") {
                    let strClickEventDate = moment(event.date).format("YYYY-MM-DD");
                    let clickEventNextDate: Date = new Date(moment(event.date).format("YYYY/MM/DD"));
                    clickEventNextDate.setDate(clickEventNextDate.getDate() + 1);
                    let todayDate = moment(new Date()).format("YYYY-MM-DD");

                    if (new Date(strClickEventDate) <= new Date(todayDate)) {
                        this.isUnavailabilityAllowed = false;
                    }
                    else {
                        this.isUnavailabilityAllowed = this.profileData.isUnavailabilityAllowed;
                    }

                    this.calSelectedDates ={ startDate: eventStart, endDate: clickEventNextDate };

                    this.sharedRequest = {
                        type: 1,
                        selfSchedule: needFV,
                        request: this.checkIfFutureDate(strClickEventDate),
                        availability: this.isUnavailabilityAllowed,
                        calSelectedDates: this.calSelectedDates,
                        status: this.scheduleStatus,
                        isSelfScheduledEvent: false,
                        SelfScheduleDepartments: event.selfScheduleDepartments                      
                    };
                }
                else if (event.type == "Pending" || (event.type == "Assignment" && event.status == "Pending") ||
                    (this.scheduleStatus.toUpperCase() != "POSTED" && this.isSelfScheduleAllowed == true &&
                        event.type == "Assignment" && event.status == "Scheduled")) //
                {
                    let strClickEventDate = moment(event.date).format("YYYY-MM-DD");
                    let clickEventNextDate: Date = new Date(moment(event.date).format("YYYY/MM/DD"));
                    clickEventNextDate.setDate(clickEventNextDate.getDate() + 1);
                    let todayDate = moment(new Date()).format("YYYY-MM-DD");

                    if (new Date(strClickEventDate) <= new Date(todayDate)) {
                        this.isUnavailabilityAllowed = false;
                    }
                    else {
                        this.isUnavailabilityAllowed = this.profileData.isUnavailabilityAllowed;
                    }

                    this.calSelectedDates = { startDate: eventStart, endDate: clickEventNextDate };

                    this.sharedRequest = {
                        type: 1,
                        selfSchedule: true,
                        status: this.scheduleStatus,
                        request: this.checkIfFutureDate(strClickEventDate),
                        calSelectedDates: this.calSelectedDates,
                        availability: true,
                        isSelfScheduledEvent: event.isSelfScheduled
                    };
                }
                else if (event.type == "Unavailability") {
                    this.sharedRequest = {
                        type: 1,
                        selfSchedule: false,
                        request: false,
                        availability: true,
                        calSelectedDates: {},
                        isUnavailabilityEvent: true,
                        isSelfScheduledEvent: false,
                        status: this.scheduleStatus
                    }; /*needApproval: false,*/
                }
                else if ((event.status == "Requested" || event.status == "Pending") && event.type == "Trade") {
                    this.sharedRequest = {
                        type: 3,
                        val: true,
                    };
                }
                else if (event.type == "Request") {
                    let strClickEventDate = moment(event.date).format("YYYY-MM-DD");
                    const calSelectedDates = { startDate: eventStart, endDate: moment(eventStart).add(1, 'days') };
                    this.sharedRequest = {
                        type: 1,
                        selfSchedule: false,
                        request: true,
                        additionalRequest: this.checkIfFutureDate(strClickEventDate),
                        availability: false,
                        calSelectedDates,
                        isSelfScheduledEvent: false,
                        status: this.scheduleStatus                       
                    };
                } //event.type = "Assignment"
                else {
                    this.sharedRequest = {
                        type: 2,
                        event: this.checkIfXHours(event,12),
                        assignmentDetail: true,
                        status: this.scheduleStatus,
                        isSymphonyUser: this.profileData.useMySchedulerOperatingRoom? true :false
                    };
                }
            }
            if (new Date(event.date) < new Date(this.scheduleStartDate)) {
                this.prevMonth();
            }
            else if (new Date(event.date) > new Date(this.scheduleEndDate)) {
                this.nextMonth();
            }
        }

        checkIfXHours(event,hrs) {
            return moment().diff(moment(event.date), "hours") < -hrs;
        }

        checkIfFutureDate(event) {
            return moment().diff(moment(event), "hours") < 0;
        }

        handleEvents(events: EventApi[]) {
            this.currentEvents = events;
        }

        getWeeklyHours(flag: string) {
            let totalHrs = 0,
                totalMins = 0,
                weekStartDate: Date = new Date(this.calenderStartforCSD),
                weekEndDate: Date = new Date(this.calenderStartforCSD),
                weekEvents!: Event[];

            if (this.weeksInSchedule == 6) {
                if (flag == "Week1") {
                    weekEndDate.setDate(this.calenderStartforCSD.getDate() + 6);
                } else if (flag == "Week2") {
                    weekStartDate.setDate(this.calenderStartforCSD.getDate() + 7);
                    weekEndDate.setDate(this.calenderStartforCSD.getDate() + 13);
                } else if (flag == "Week3") {
                    weekStartDate.setDate(this.calenderStartforCSD.getDate() + 14);
                    weekEndDate.setDate(this.calenderStartforCSD.getDate() + 20);
                }
                else if (flag == "Week4") {
                    weekStartDate.setDate(this.calenderStartforCSD.getDate() + 21);
                    weekEndDate.setDate(this.calenderStartforCSD.getDate() + 27);
                }
                else if (flag == "Week5") {
                    weekStartDate.setDate(this.calenderStartforCSD.getDate() + 28);
                    weekEndDate.setDate(this.calenderStartforCSD.getDate() + 34);
                }
                else {
                    weekStartDate.setDate(this.calenderStartforCSD.getDate() + 35);
                    weekEndDate.setDate(this.calenderStartforCSD.getDate() + 41);
                }
            }
            else //--- this.weeksInSchedule == 4
            {
                if (flag == "Week1") {
                    weekEndDate.setDate(this.calenderStartforCSD.getDate() + 6);
                } else if (flag == "Week2") {
                    weekStartDate.setDate(this.calenderStartforCSD.getDate() + 7);
                    weekEndDate.setDate(this.calenderStartforCSD.getDate() + 13);
                } else if (flag == "Week3") {
                    weekStartDate.setDate(this.calenderStartforCSD.getDate() + 14);
                    weekEndDate.setDate(this.calenderStartforCSD.getDate() + 20);
                } else {
                    weekStartDate.setDate(this.calenderStartforCSD.getDate() + 21);
                    weekEndDate.setDate(this.calenderStartforCSD.getDate() + 27);
                }
            }

            weekEvents = this.events.filter(
                (event: Event) =>
                    new Date(event.date) >= weekStartDate &&
                    new Date(event.date) <= weekEndDate &&
                    (event.isCommitment && (event.type == "Pending" || event.type == "Assignment" ||
                        event.type == "Request" || event.type == "Trade"))
            );

            weekEvents.forEach((event: Event) => {
                totalHrs += event.hours;
                totalMins += event.minutes;
            });
            if (this.weekendCount) {
                weekEvents.forEach((event: Event) => {                    
                    if(event.isWeekend) {
                        this.totalWeekendHours += event.hours
                    }
                });
            }
            return totalHrs + totalMins / 60;
        }

        checkHomeDeptNeeds() {
            let
                // weekStartDate: Date = new Date(this.calenderStartforCSD),
                // weekEndDate: Date = new Date(this.calenderStartforCSD),
                weekEvents!: Event[];
               let week1Hours = this.getWeeklyHours("Week1"),
                week2Hours = this.getWeeklyHours("Week2"),
                week3Hours = this.getWeeklyHours("Week3"),
                week4Hours = this.getWeeklyHours("Week4"),
                week5Hours = (this.weeksInSchedule == 6 ? this.getWeeklyHours("Week5") : 0),
                week6Hours = (this.weeksInSchedule == 6 ? this.getWeeklyHours("Week6") : 0);
            if (this.weeksInSchedule == 6) {

                    if((week1Hours + week2Hours) < 2 * this.guranteedHrs)
                    {   let weekStartDate: Date = new Date(this.calenderStartforCSD),
                         weekEndDate: Date = new Date(this.calenderStartforCSD);
                        weekEndDate.setDate(this.calenderStartforCSD.getDate() + 13);
                        this.checkPrimaryDeptNeeds(weekStartDate, weekEndDate,false);

                    }
                    //2nd pay periods
                    if( (week3Hours + week4Hours) < 2 * this.guranteedHrs )
                    {
                         let weekStartDate: Date = new Date(this.calenderStartforCSD),
                         weekEndDate: Date = new Date(this.calenderStartforCSD);
                    weekStartDate.setDate(this.calenderStartforCSD.getDate() + 14);
                    weekEndDate.setDate(this.calenderStartforCSD.getDate() + 27);
                    this.checkPrimaryDeptNeeds(weekStartDate, weekEndDate,false);

                    }

                    //3rd pay periods
                    if( (week5Hours + week6Hours) < 2 * this.guranteedHrs )
                    {
                         let weekStartDate: Date = new Date(this.calenderStartforCSD),
                         weekEndDate: Date = new Date(this.calenderStartforCSD);
                    weekStartDate.setDate(this.calenderStartforCSD.getDate() + 28);
                    weekEndDate.setDate(this.calenderStartforCSD.getDate() + 41);
                    this.checkPrimaryDeptNeeds(weekStartDate, weekEndDate,false);

                    }
                     //first pay periods
                    if(this.displayWSC)
                    {
                         let weekStartDate: Date = new Date(this.calenderStartforCSD),
                         weekEndDate: Date = new Date(this.calenderStartforCSD);
                        weekStartDate.setDate(this.calenderStartforCSD.getDate());
                        weekEndDate.setDate(this.calenderStartforCSD.getDate() + 41);
                        this.checkPrimaryDeptNeeds(weekStartDate, weekEndDate,true);
                    }
            }
            else //--- this.weeksInSchedule == 4
            {
                //1st pay periods
                 if((week1Hours + week2Hours) < 2 * this.guranteedHrs)
                {
                     let weekStartDate: Date = new Date(this.calenderStartforCSD),
                         weekEndDate: Date = new Date(this.calenderStartforCSD);
                    weekEndDate.setDate(this.calenderStartforCSD.getDate() + 13);
                    this.checkPrimaryDeptNeeds(weekStartDate, weekEndDate,false);

                }
               //end pay periods
                //2nd pay periods
                    if( (week3Hours + week4Hours) < 2 * this.guranteedHrs )
                    {
                         let weekStartDate: Date = new Date(this.calenderStartforCSD),
                         weekEndDate: Date = new Date(this.calenderStartforCSD);
                    weekStartDate.setDate(this.calenderStartforCSD.getDate() + 14);
                    weekEndDate.setDate(this.calenderStartforCSD.getDate() + 27);
                    this.checkPrimaryDeptNeeds(weekStartDate, weekEndDate, false);

                    }
                     if(this.displayWSC)
                    {
                        let weekStartDate: Date = new Date(this.calenderStartforCSD),
                         weekEndDate: Date = new Date(this.calenderStartforCSD);
                        weekStartDate.setDate(this.calenderStartforCSD.getDate());
                        weekEndDate.setDate(this.calenderStartforCSD.getDate() + 27);
                        this.checkPrimaryDeptNeeds(weekStartDate, weekEndDate, true);
                    }
            }
        }
     checkPrimaryDeptNeeds(startDate, endDate, isWeekend)
     {
         let payperiodEvents;
         if(isWeekend)
         {
           payperiodEvents = this.events.filter(
                (event: Event) =>
                    new Date(event.date) >= startDate &&
                    new Date(event.date) <= endDate && event.isWeekend == true
            );
         }
         else
         {
          payperiodEvents = this.events.filter(
                (event: Event) =>
                    new Date(event.date) >= startDate &&
                    new Date(event.date) <= endDate
            );
         }
            payperiodEvents.forEach(event => {
               if(event.type == "Need" && event.hasEventSelfScheduleNeedsInPrimaryDept)
            {
                 var isOtherAssignmentExist = this.events.find(
                        (evt: Event) =>
                            moment(evt.date).format("YYYY-MM-DD") ==
                            moment(event.date).format("YYYY-MM-DD")
                            && evt.type != "Need"
                    );
                    if (isOtherAssignmentExist == undefined || isOtherAssignmentExist == null) {
                        this.hasSelfScheduleNeedsInPrimaryDept = true;
                    }
            }
            });
     }

        getPendingEvents() {
            return this.events.filter(
                (event: Event) => event.type == "Pending"
            );
        }

        getWeekendShiftCommitmentCount() {
            let countWSC: number = 0;
            let payPeriodStartDate: Date = new Date(this.calenderStartforCSD),
                payPeriodEndDate: Date = new Date(payPeriodStartDate),
                payPeriodEvents!: Event[];

            if (this.weeksInSchedule == 6) {
                payPeriodEndDate.setDate(payPeriodStartDate.getDate() + 41);
            }
            else //this.weeksInSchedule == 4
            {
                payPeriodEndDate.setDate(payPeriodStartDate.getDate() + 27);
            }

            payPeriodEvents = this.events.filter(
                (event: Event) =>
                    new Date(event.date) >= payPeriodStartDate &&
                    new Date(event.date) <= payPeriodEndDate &&
                    (event.isCommitment && (event.type == "Pending" || event.type == "Assignment" ||
                        event.type == "Request"))
            );

            payPeriodEvents.forEach((event: Event) => {
                if (event.isWeekend) {
                    countWSC++;
                }
            });
            return countWSC;
        }

        getCommitmentSubmitDetails() {
            const { selfScheduleToCommitment, selfSchedulePastCommitment, limitSelfScheduleToTarget } = this.profileData;
            this.weekendCount = true;
            this.totalWeekendHours = 0;
            this.objCommitmentSubmit = {
                scheduleId: this.scheduleId,
                guranteedHours: this.guranteedHrs,
                otHours: this.otHrs,
                maxSelfScheduleHours: this.maxSelfScheduleHours,
                employeeType: this.employeeType,
                week1Hours: this.getWeeklyHours("Week1"),
                week2Hours: this.getWeeklyHours("Week2"),
                week3Hours: this.getWeeklyHours("Week3"),
                week4Hours: this.getWeeklyHours("Week4"),
                week5Hours: (this.weeksInSchedule == 6 ? this.getWeeklyHours("Week5") : 0),
                week6Hours: (this.weeksInSchedule == 6 ? this.getWeeklyHours("Week6") : 0),
                weekendHours: this.totalWeekendHours,
                displayWSC: this.displayWSC,
                countWSC: this.displayWSC ? this.getWeekendShiftCommitmentCount() : 0,
                reqCountWSC: this.reqCountWSC,
                scheduleStatus: this.scheduleStatus.toUpperCase(),
                pendingShifts: this.getPendingEvents().length,
                pendingShiftList: this.getPendingEvents(),
                selfScheduleToCommitment,
                selfSchedulePastCommitment,
                limitSelfScheduleToTarget,
                weeksInSchedule: this.weeksInSchedule,
                hasSelfScheduleNeedsInPrimaryDept: this.hasSelfScheduleNeedsInPrimaryDept,
                defaultSelfScheduleState: this.defaultSelfScheduleState,
                isTierOpen: this.isTierOpen
            };
            this.weekendCount = false;
        }

        async prevMonth() {
            if (this.currentShceduleIndex > 0) {
                this.currentShceduleIndex -= 1;
            }
            await this.getScheduleDetailsOnNavigation(this.currentShceduleIndex);
            let prevWeek = this.userSchedules[this.currentShceduleIndex];
            this.scheduleStartDate = prevWeek.startDate;
            this.scheduleEndDate = prevWeek.endDate;
            this.scheduleStatus = prevWeek.status;
            this.currentMonthCalendarApi.gotoDate(prevWeek.startDate);
            this.setCalendarEvents(this.currentShceduleIndex);
            localStorage.setItem("sIndex", this.currentShceduleIndex.toString());
        }

        getCurrentWeekSchedule(): any {
            var currdate = new Date();
            var currentsched;

            this.userSchedules.forEach((sched: any) => {
                var startDt, endDt, currDt;
                startDt = moment(sched.startDate).format("DD/MM/YYYY");
                currDt = moment(currdate).format("DD/MM/YYYY");
                endDt = moment(sched.endDate).format("DD/MM/YYYY");
                //getting week start date from schedules, based on current date

                var sDt = startDt.split("/");
                var cDt = currDt.split("/");
                var eDt = endDt.split("/");

                var from = new Date(sDt[2], parseInt(sDt[1])-1, sDt[0]);  // -1 because months are from 0 to 11
                var to   = new Date(eDt[2], parseInt(eDt[1])-1, eDt[0]);
                var check = new Date(cDt[2], parseInt(cDt[1])-1, cDt[0]);

                if(check >= from && check <= to){
                    currentsched = sched;
                    return;
                }
            });

            this.currentShceduleIndex = this.userSchedules.indexOf(currentsched);
            this.scheduleStartDate = currentsched.startDate;
            this.scheduleEndDate = currentsched.endDate;

            return currentsched;
        }

        //get current week schedules
        async todayDate() {
            await this.getScheduleDetailsOnNavigation(0);
            localStorage.removeItem("sIndex");
            let todaysWeek = this.getCurrentWeekSchedule();
            this.currentMonthCalendarApi.gotoDate(todaysWeek.startDate);
            this.setCalendarEvents(this.currentShceduleIndex);
        }

        //get next month schedules
        async nextMonth() {
            this.currentShceduleIndex += 1;
            await this.getScheduleDetailsOnNavigation(this.currentShceduleIndex);
            const nextWeek = this.userSchedules[this.currentShceduleIndex];
            this.scheduleStartDate = nextWeek.startDate;
            this.scheduleEndDate = nextWeek.endDate;
            this.scheduleStatus = nextWeek.status;
            this.currentMonthCalendarApi.gotoDate(nextWeek.startDate);
            this.setCalendarEvents(this.currentShceduleIndex);
            localStorage.setItem("sIndex", this.currentShceduleIndex.toString());
        }

        showWelcomeModal(){
            if(this.profileData.isFirstTimeLogin && 
                !this.profileData.isAdmin) {
                this.isWelcomeModalVisible = true;
            }
            else{
                this.isWelcomeModalVisible = false;
            }
        }

        async onCloseWelcomePopup(){
            let data = {
                        isFirstTimeLogin: true,
                    };
            await this.$store.dispatch('profile/updateWelcomePopupstatus', data)
                .then((res: any) => {
                    this.isWelcomeModalVisible = false;
                })
                .catch((err: any) => {
                    if (err) {
                        console.log(err);
                        this.isWelcomeModalVisible = false;
                    }
                });
        }
    }

